import { horizontalDividerBlock } from '../common'
import type { ImpactType, MetricAssignmentType } from '~/types/types'
import { handleMetricAssignmentCard } from './metric_assignment_info'

export const handleMeasurementAndKpis = (impacts: ImpactType[], _locale: string) => {
  const dedupedById = new Map<number, MetricAssignmentType>()
  for (const assignment of (impacts || []).flatMap((impact) => impact.metricAssignments || [])) {
    if (!assignment?.id) continue
    if (!dedupedById.has(assignment.id)) dedupedById.set(assignment.id, assignment)
  }

  const metricAssignments = Array.from(dedupedById.values())
  return [
    horizontalDividerBlock(),
    {
      text: 'Our Measurement and KPIs',
      width: '*',
      style: ['blueHeader'],
      // pageBreak: 'before',
    },
    {
      text: 'We track the impact of our solutions using the following KPIs. The target values represent our yearly goals, while the actual values (when available) show what we\'ve achieved. The target progress indicates how close we are to reaching our goal for the forecasted period.',
      style: 'message',
      margin: [0, 10, 0, 0],
    },
    ...metricAssignments.map((ma: MetricAssignmentType) =>
      handleMetricAssignmentCard(ma, ma.metricValues || [], _locale),
    ),
    horizontalDividerBlock(),
  ]
}
